import { Machine } from '../../gql/generated';

/** Where the machine stands: the customer record's name, then the plant. */
export function machineSubtitle(machine: Machine): string | undefined {
  const parts: string[] = [];
  if (machine.customer?.name) {
    parts.push(machine.customer.name);
  }
  if (machine.plant?.displayName) {
    parts.push(machine.plant.displayName);
  }
  return parts.join(' · ') || undefined;
}
